<template>
    <div class="popup">
        <van-popup
            v-model="popupApprove"
            position="center"
            :close-on-click-overlay='true'
        >
            <div class="dig">
                <div class="body">
                    <div class="img"><img src="../../../assets/img/b2b/pic.png" alt=""></div>
                    <div class="title">开钱包，做认证会员！</div>
                    <div class="content">开通钱包，即可看超低批发价，海量商品任你选～。</div>
                </div>
                <div class="ft" @click="onHide">
                    去认证
                </div>
            </div>
        </van-popup>
    </div>
</template>
<script>
export default {
    name: 'popup',
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
        popupApprove: {
            get () {
                return this.visible
            },
            set () {
                this.$emit('update:visible')
            }
        }
    },
    methods: {
        onHide () {
            this.$emit('update:visible')
            this.onRz()
        },
        onRz () {
            this.$router.push({ path: '/b2b/company/index' })
        }
    }
}
</script>
<style lang="scss" scoped>
.dig{
    background: #ffffff;
    width: 590px;
    margin: 0 auto;
    border-radius: 12px;
    .body{
        text-align: center;
        color: #333333;
        padding: 0 56px;
        .img{
            width: 320px;
            height: 228px;
            margin: 0 auto;
        }
        .title{
            font-size: 34px;
            margin-top: 18px;
            margin-bottom: 32px;
        }
        .content{
            font-size: 30px;
            margin-bottom: 48px;
        }
    }
    .ft{
        font-size: 32px;
        color: #FF7A45;
        height: 96px;
        line-height: 96px;
        text-align: center;
        border-top: 2px solid #f5f5f5;
    }
}
/deep/ .van-popup{
    background: none;
    z-index: 10000 !important;
}
</style>